<template>
  <div class="flex w-100">
    <div class=" col-md-9 col-xs-9 checkbox-option flex">
      <div class="mr10">
        {{ option.title }}
        <span class="price bold" v-if="!qty">+{{ option.price }} <span>грн</span></span>
        <span class="price bold" v-else> +{{ total }} <span>грн</span></span>
      </div>
    </div>
    <div class="col-xs-3 flex end-md end-xs">
      <div class="pointer qty-button" v-if="qty > 0" @click="addAndRemoveCustomOption(rootOption, option, 'minus')">
        <span class="material-icons qty-icon">remove</span>
      </div>
      <span class="custom-option-number" v-if="qty > 0">{{ qty }}</span>
      <div class="pointer qty-button" @click="addAndRemoveCustomOption(rootOption, option, 'plus')">
        <span class="material-icons qty-icon">add</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductQtyOption",
  props: {
    option: {
      type: Object
    },
    rootOption: {
      type: Object
    }
  },
  data () {
    return {
      qty: 0
    }
  },
  methods: {
    addAndRemoveCustomOption (option, opval = null, selected = '') {
      if (selected === 'minus' && !this.qty) return
      selected === 'plus' ? this.qty++ : this.qty--
      let isDeleteOption = !this.qty
      opval.qty = this.qty
      this.$emit('addOption', option, opval, isDeleteOption)
    }
  },
  computed: {
    total () {
      return (this.option.price * this.qty) % 1 ? parseFloat(this.option.price * this.qty).toFixed(2) : this.option.price * this.qty
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
$color-tertiary: color(tertiary);
$color-black: color(black);
$color-hover: color(tertiary, $colors-background);

$bg-secondary: color(secondary, $colors-background);
$color-secondary: color(secondary);
$color-error: color(error);

.custom-option-number {
  text-align: center;
  border-style: solid;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.09px;
  color: #111111;
  border-width: 0 0 0 0;
  width: 22px;
  outline: none;
  align-self: center;
  &::-webkit-outer-spin-button,&::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.custom-option > label {
  font-weight: bold;
  margin-bottom: 10px;
}

.error {
  color: $color-error;
  padding-top: 5px;
  display: block;
}
$color-silver: color(silver);
$color-active: color(secondary);
$color-white: color(white);

.relative label {
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 16px;
  line-height: 30px;
  word-break: break-word;
  &.radio-label{
    &:before {
      border-radius: 50%;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 22px;
    height: 22px;
    background-color: $color-white;
    border: 1px solid $color-silver;
    cursor: pointer;
  }
}
input[type='text'] {
  transition: 0.3s all;
  &::-webkit-input-placeholder {
    color: $color-tertiary;
  }
  &::-moz-placeholder {
    color: $color-tertiary;
  }
  &:hover,
  &:focus {
    outline: none;
    border-color: $color-black;
  }
  background: inherit;
}
input[type='radio'], input[type='checkbox']  {
  position: absolute;
  top: -2px;
  left: 4px;
  &:checked + label {
    &:before {
      background-color: $color-silver;
      border-color: $color-silver;
      cursor: pointer;
    }
    &:after {
      content: '';
      position: absolute;
      top: 9px;
      left: 5px;
      width: 11px;
      height: 5px;
      border: 3px solid $color-white;
      border-top: none;
      border-right: none;
      background-color: $color-silver;
      transform: rotate(-45deg);
    }
  }
  &:hover,
  &:focus {
    + label {
      &:before {
        border-color: $color-active;
      }
    }
  }
  &:disabled + label {
    cursor: not-allowed;
    &:hover,
    &:focus {
      &:before {
        border-color: $color-silver;
        cursor: not-allowed;
      }
    }
  }
}
.price{
  font-size: 16px;
  text-align: center;
  line-height: 30px;
}
.checkbox-option {
  align-items: center;
}
.select-wrapper {
  &::after {
    content: '';
    display: block;
    position: absolute;
    top: 1rem;
    right: 10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 8px 6px 0 6px;
    border-color: $color-tertiary transparent transparent transparent;
    pointer-events: none;
  }

  select {
    border: none;
    color: #000;
    border-bottom: 1px solid $color-tertiary;
    width: 100%;
    -moz-appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    background-color: transparent;

    &:hover,
    &:focus {
      outline: none;
      border-color: #11bb2e;
    }

    &:disabled,
    &:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  label {
    color: #999;
    position: absolute;
    pointer-events: none;
    user-select: none;
    top: 10px;
    left: 8px;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
  }
  select:focus ~ label, select:not(.empty) ~ label {
    top: -10px;
    font-size: 14px;
    color: #11bb2e;
  }
}
.block-option {
  align-items: center;
}
.qty-icon {
  font-size: 17px;
  color: #11bb2e;
  border: 1px solid #11bb2e;
  border-radius: 50%;
}
.qty-button {
  align-self: center;
}
</style>
